import auth from "./auth";
import employee from './employee'
import document from './document'
import utils from "./utils/utils";
import policy from "./policy";
import settings from "./settings";
import user from "./user";
import holiday from "./holiday";
import leave from "./leave";
import event from "./event";
import notes from "./notes";
import chat from './chat';
import attendance from "./attendance";
import asset from "./asset";
import poll from "./poll";
import wish from "./celebration";


const server = {
    auth: auth,
    user: user,
    document: document,
    employee: employee,
    enums: settings,
    policy: policy,
    holiday: holiday,
    utils: utils,
    leave: leave,
    event: event,
    notes: notes,
    settings: settings,
    chat: chat,
    attendance: attendance,
    wish: wish,
    asset: asset,
    poll: poll,
};

export default server;
